export default location &&
(
    location.href.indexOf('www.oxford-royale.co.uk') > -1 ||
        location.href.indexOf('webadmin.oxford-royale.co.uk') > -1 ||
        location.href.indexOf('portal.oxford-royale.co.uk') > -1 ||
        location.href.indexOf('www.oxford-royale.com') > -1 ||
        location.href.indexOf('webadmin.oxford-royale.com') > -1 ||
        location.href.indexOf('portal.oxford-royale.com') > -1 ||
        location.href.indexOf('www.academyroyaleinternational.com') > -1 ||
        location.href.indexOf('webadmin.academyroyaleinternational.com') > -1 ||
        location.href.indexOf('portal.academyroyaleinternational.com') > -1 ||
        ((location.href.indexOf('apply.oxford-royale.com') > -1 || location.href.indexOf('apply.academyroyaleinternational.com') > -1) && location.href.indexOf('flywire-test') === -1)
);

